import type { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { englishIqResultSchema } from '../schemas';

export const completeEnglishIqV1ResponseSchema: z.ZodSchema<
  IAPI<z.infer<typeof englishIqResultSchema>>
> = createApiResponseSchema(englishIqResultSchema) as z.ZodSchema<
  IAPI<z.infer<typeof englishIqResultSchema>>
>;

export type ICompleteEnglishIqV1Response = IAPI<z.infer<typeof englishIqResultSchema>>;
